export const variableTypes = {
  NUMBER: 'number',
  STRING: 'string',
  DATE_TIME: 'datetime',
  DATE_TIME_DASH: 'date-time',
  BOOLEAN: 'boolean',
  INTEGER: 'integer'
};

export const VARIABLE_TYPES_ARRAY = [
  {
    label: 'Datetime',
    value: variableTypes.DATE_TIME
  },
  {
    label: 'String',
    value: variableTypes.STRING
  },
  {
    label: 'Number',
    value: variableTypes.NUMBER
  },
  {
    label: 'Integer',
    value: variableTypes.INTEGER
  },
  {
    label: 'Boolean',
    value: variableTypes.BOOLEAN
  }
];
